export const engagementPresetDraganddropTemplates = "/engagement/preset_draganddrop_templates";
